/**
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see https://ckeditor.com/legal/ckeditor-oss-license
 */

// Custom richCombo for language selection.
// Replaces the native Language menubutton so the trigger shows the active language name.
// Uses editor.applyStyle/removeStyle directly (same pattern as the Format richCombo) instead
// of execCommand, which avoids relying on the Language plugin's private closure.
if (!(CKEDITOR.plugins.registered && "languageCombo" in CKEDITOR.plugins.registered)) {
CKEDITOR.plugins.add("languageCombo", {
  requires: "richcombo,language",
  init: function (editor) {
    var languageList = editor.config.language_list || []
    var langMap = {}
    var langDirMap = {}

    for (var i = 0; i < languageList.length; i++) {
      var parts = languageList[i].split(":")
      langMap[parts[0]] = parts[1]
      langDirMap[parts[0]] = parts[2] && parts[2].toLowerCase() === "rtl" ? "rtl" : "ltr"
    }

    editor.ui.addRichCombo("LanguageCombo", {
      label: "Language",
      title: "Select text and mark the language for accessibility tools",
      toolbar: "language",
      defaultLabel: "Language",
      multiSelect: false,
      allowedContent: "span[!lang,dir]",
      requiredContent: "span[lang]",
      panel: {
        css: [CKEDITOR.skin.getPath("editor")],
        multiSelect: false,
        attributes: { "aria-label": "Language" },
      },

      init: function () {
        for (var j = 0; j < languageList.length; j++) {
          var p = languageList[j].split(":")
          this.add(p[0], p[1], p[1])
        }
        this.commit()
      },

      // Called when a language item is clicked in the dropdown panel.
      // Mirrors the Format combo pattern: editor.focus() restores the locked
      // selection, then applyStyle/removeStyle wraps/unwraps the selection.
      onClick: function (value) {
        editor.focus()
        editor.fire("saveSnapshot")

        var dir = langDirMap[value] || "ltr"
        var style = new CKEDITOR.style({ element: "span", attributes: { lang: value, dir: dir } })
        var path = editor.elementPath()

        if (style.checkActive(path, editor)) {
          editor.removeStyle(style)
        } else {
          editor.applyStyle(style)
        }

        // Deferred snapshot matches the Format combo pattern for correct undo stacking.
        setTimeout(function () {
          editor.fire("saveSnapshot")
        }, 0)
        // Force a selectionChange so the trigger text updates immediately.
        editor.forceNextSelectionCheck()
      },

      // Highlight the active language when the panel opens.
      onOpen: function () {
        this.showAll()
        var langPlugin = CKEDITOR.plugins.get("language")
        if (langPlugin) {
          var el = langPlugin.getCurrentLangElement(editor)
          this.setValue(el ? el.getAttribute("lang") : "")
        }
      },

      // Keep the trigger in sync as the cursor moves through the document.
      onRender: function () {
        var combo = this
        editor.on("selectionChange", function () {
          var langPlugin = CKEDITOR.plugins.get("language")
          if (!langPlugin) return
          var el = langPlugin.getCurrentLangElement(editor)
          var langCode = el ? el.getAttribute("lang") : ""
          combo.setValue(langCode, langMap[langCode] || "")
        })
      },
    })
  },
})
}

CKEDITOR.editorConfig = function (config) {
  config.versionCheck = false
  config.language = "en"
  config["removePlugins"] = "resize,magicline,elementspath,exportpdf,easyimage,cloudservices"
  config.removeButtons = "About"
  config["resize_enabled"] = false
  // divarea replaces the iframe-based editing area with a contenteditable div,
  // avoiding CKEditor's nonce-less inline bootstrap <script> that CSP (script-src
  // without 'unsafe-inline', MAKE-4214) now blocks.
  config.extraPlugins = ["justify", "colorbutton", "bidi", "colordialog", "editorplaceholder", "languageCombo", "divarea"]
  config.colorButton_colors =
    "59b99e,66c97a,5196d6,925cb1,525f6f,eac645,4c9e86,57ac68,427eb4,8548a8,303e4f,e79f3c,d8823b,d65846,e26ca9,98a5a6,dddddd,ffffff,c45c24,b14434,e20074,828c8d,828c8d,000000"

  const textAreaWithPlaceholder = document.querySelector(".ck_editor_place_holder_enabled")

  if (textAreaWithPlaceholder) {
    const customPlaceholder = textAreaWithPlaceholder.getAttribute("place_holder") || ""
    config.editorplaceholder = customPlaceholder
  }

  const openaiPluginEnabled = document.querySelector(".openai-plugin-enabled") !== null

  if (openaiPluginEnabled) {
    CKEDITOR.plugins.addExternal("openai", "/ckeditor4/plugins/openai/plugin.js")

    config.extraPlugins.push("openai")
  }

  config.language_list = [
    "af:Afrikaans",
    "sq:Albanian",
    "am:Amharic",
    "ar:Arabic:rtl",
    "hy:Armenian",
    "az:Azerbaijani",
    "eu:Basque",
    "be:Belarusian",
    "bn:Bengali",
    "bs:Bosnian",
    "bg:Bulgarian",
    "ca:Catalan",
    "ceb:Cebuano",
    "ny:Chichewa",
    "zh-cn:Chinese (Simplified)",
    "zh-tw:Chinese (Traditional)",
    "co:Corsican",
    "hr:Croatian",
    "cs:Czech",
    "da:Danish",
    "nl:Dutch",
    "en:English",
    "eo:Esperanto",
    "et:Estonian",
    "tl:Filipino",
    "fi:Finnish",
    "fr:French",
    "fy:Frisian",
    "gl:Galician",
    "ka:Georgian",
    "de:German",
    "el:Greek",
    "gu:Gujarati",
    "ht:Haitian Creole",
    "ha:Hausa",
    "haw:Hawaiian",
    "he:Hebrew:rtl",
    "hi:Hindi",
    "hmn:Hmong",
    "hu:Hungarian",
    "is:Icelandic",
    "ig:Igbo",
    "id:Indonesian",
    "ga:Irish",
    "it:Italian",
    "ja:Japanese",
    "jv:Javanese",
    "kn:Kannada",
    "kk:Kazakh",
    "km:Khmer",
    "rw:Kinyarwanda",
    "ko:Korean",
    "ku:Kurdish:rtl",
    "ky:Kyrgyz",
    "lo:Lao",
    "la:Latin",
    "lv:Latvian",
    "lt:Lithuanian",
    "lb:Luxembourgish",
    "mk:Macedonian",
    "mg:Malagasy",
    "ms:Malay",
    "ml:Malayalam",
    "mt:Maltese",
    "mi:Maori",
    "mr:Marathi",
    "mn:Mongolian",
    "my:Myanmar (Burmese)",
    "ne:Nepali",
    "nb:Norwegian",
    "or:Odia",
    "ps:Pashto:rtl",
    "fa:Persian:rtl",
    "pl:Polish",
    "pt:Portuguese",
    "pt-br:Portuguese (Brazil)",
    "pa:Punjabi",
    "ro:Romanian",
    "ru:Russian",
    "sm:Samoan",
    "gd:Scottish Gaelic",
    "sr:Serbian",
    "st:Sesotho",
    "sn:Shona",
    "sd:Sindhi:rtl",
    "si:Sinhala",
    "sk:Slovak",
    "sl:Slovenian",
    "so:Somali",
    "es:Spanish",
    "su:Sundanese",
    "sw:Swahili",
    "sv:Swedish",
    "tg:Tajik",
    "ta:Tamil",
    "tt:Tatar",
    "te:Telugu",
    "th:Thai",
    "tr:Turkish",
    "tk:Turkmen",
    "uk:Ukrainian",
    "ur:Urdu:rtl",
    "ug:Uyghur:rtl",
    "uz:Uzbek",
    "vi:Vietnamese",
    "cy:Welsh",
    "xh:Xhosa",
    "yi:Yiddish:rtl",
    "yo:Yoruba",
    "zu:Zulu",
  ]

  config.toolbar_Pure = [
    {
      name: "clipboard",
      items: ["Cut", "Copy", "Paste", "-", "Undo", "Redo"],
    },
    {
      name: "basicstyles",
      items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"],
    },
    "/",
    {
      name: "paragraph",
      items: [
        "NumberedList",
        "BulletedList",
        "-",
        "Outdent",
        "Indent",
        "-",
        "Blockquote",
        "-",
        "JustifyLeft",
        "JustifyCenter",
        "JustifyRight",
        "JustifyBlock",
        "-",
        "BidiLtr",
        "BidiRtl",
      ],
    },
    {
      name: "link",
      items: ["Link"],
    },
    "/",
    {
      name: "styles",
      items: ["Format"],
    },
    {
      name: "colors",
      items: ["TextColor", "BGColor"],
    },
    {
      name: "language",
      items: ["LanguageCombo"],
    },
  ]

  config.format_h1 = {
    element: "h1",
    attributes: {
      class: "contentTitle1",
      style: "font-weight: bold; font-size: 18px;",
    },
  }

  config.format_h2 = {
    element: "h2",
    attributes: {
      class: "contentTitle2",
      style: "font-weight: bold; font-size: 16px;",
    },
  }

  config.format_h3 = {
    element: "h3",
    attributes: {
      class: "contentTitle3",
      style: "font-weight: bold; font-size: 14px;",
    },
  }

  config.toolbar               = "Pure";
  config.forcePasteAsPlainText = true;
  config.linkShowTargetTab     = false;
  config.enterMode             = CKEDITOR.ENTER_DIV;

  return true
}

CKEDITOR.on("dialogDefinition", function (ev) {
  if (ev.data.name === "link") {
    ev.data.definition.getContents("target").get("linkTargetType")["default"] = "_blank"
  }
})

CKEDITOR.on("instanceReady", function (event) {
  if (!document.getElementById("cke-language-panel-style")) {
    const style = document.createElement("style")
    style.id = "cke-language-panel-style"
    // .cke_combopanel is in the host-page DOM (it wraps the panel iframe),
    // so !important here overrides CKEditor's inline height and the skin CSS.
    style.textContent =
      ".cke_combopanel { height: 30vh !important; max-height: 30vh !important; } .cke_panel_frame { height: 100% !important; }"
    document.head.appendChild(style)
  }

  // Guard against a CKEditor core crash (Sentry PLAY-2581): the core key handler
  // for backspace/delete calls editor.getSelection().getRanges() without a null
  // check. When the selection is detached (focus lost / editor tearing down)
  // getSelection() returns null and throws. Cancel the key event before the core
  // handler runs (priority 1) whenever there is no selection.
  event.editor.on(
    "key",
    function (evt) {
      if (!event.editor.getSelection()) {
        evt.cancel()
      }
    },
    null,
    null,
    1
  )

  event.editor.on("paste", function (evt) {
    const data = evt.data.dataValue
    const isUrl = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(data)

    if (isUrl) {
      const selectedText = evt.editor.getSelection().getSelectedText()
      const encodedHref = CKEDITOR.tools.htmlEncode(data)
      const encodedText = CKEDITOR.tools.htmlEncode(selectedText || data)

      evt.data.dataValue = '<a href="' + encodedHref + '">' + encodedText + "</a>"
    } else {
      const htmlData = evt.data.dataTransfer.getData("text/html")

      if (htmlData) {
        evt.data.dataValue = htmlData
      }
    }
  });

  event.editor.on("afterInsertHtml", function() {
    // Scope to the editable, not editor.document: under divarea the latter is the
    // host page, so querying it would touch links outside the editor.
    const editable = event.editor.editable();
    if (!editable) return;
    const elements = editable.$.querySelectorAll('a[href]:not([target])');
    elements.forEach(element => {
      element.setAttribute('target', '_blank');
    });
  });
});

// Force the default styles set to empty so the built-in style dropdown stays
// suppressed. Assign registered[] directly: .add() throws "resource already
// registered" (bundle + customConfig both run), and a guarded add would skip
// when a non-empty default was registered earlier, leaving built-in styles.
CKEDITOR.stylesSet.registered = CKEDITOR.stylesSet.registered || {}
CKEDITOR.stylesSet.registered["default"] = []
